import { Dropdown } from 'antd';
import React, { FC } from 'react';
import { ReconciliationStatus } from '@melio/payments-recon-api-client-ts';
import { IconSize, IconType, IconWrap } from '@tools/ui/dime';
import { useRecoTableQueryState } from '../../../../hooks/useRecoTableQueryState';
import { reconEnumValue } from '../../../../utils/reconEnumValue';

type IProps = {
  filters: any;
};

const FilterNavigationMenu: FC<IProps> = ({ filters }) => {
  const { setQueryState } = useRecoTableQueryState();

  return (
    <Dropdown
      menu={{
        items: [
          {
            key: 'review',
            label: 'Unreviewed records',
            onClick: () =>
              setQueryState({
                reconciliationStatus:
                  reconEnumValue<ReconciliationStatus>('review'),
                after: undefined,
                before: undefined,
                direction: undefined,
                cancellationType: undefined,
                classification: undefined,
                ...filters
              })
          },
          {
            key: 'complete',
            label: 'Completed records',
            onClick: () =>
              setQueryState({
                reconciliationStatus:
                  reconEnumValue<ReconciliationStatus>('complete'),
                after: undefined,
                before: undefined,
                direction: undefined,
                cancellationType: undefined,
                classification: undefined,
                ...filters
              })
          }
        ]
      }}
      trigger={['click']}
    >
      <IconWrap type={IconType.MoreVertical} size={IconSize.Medium} />
    </Dropdown>
  );
};

export default FilterNavigationMenu;
